<template>
  <ag-grid-vue
    style="width: 100%; height: 100%;"
    class="ag-theme-material"
    rowHeight="40"
    :gridOptions="gridOptions"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :suppressPaginationPanel="true"
    :context="context"
    @grid-ready="onGridReady"
    @gridSizeChanged="onGridSizeChanged"
  >
  </ag-grid-vue>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'TestReportModal',
  components: {
    'ag-grid-vue': AgGridVue
  },
  props: {
    rowData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'Этап',
          field: 'stage',
          width: 130,
          cellStyle: {
            'white-space': 'normal'
          }
        },
        {
          headerName: 'Шаг',
          field: 'step',
          width: 60
        },
        {
          headerName: 'Роль',
          field: 'role',
          width: 130,
          cellStyle: {
            'white-space': 'normal'
          }
        },
        {
          headerName: 'Ошибка',
          field: 'mistake',
          cellStyle: {
            'white-space': 'normal'
          }
        }
      ],
      gridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: true
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      context: {
        componentParent: this
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.resetRowHeights()
    },
    onGridSizeChanged() {
      this.gridApi.sizeColumnsToFit()
      this.gridApi.resetRowHeights()
    }
  }
}
</script>

<style>
  .ag-row .ag-cell {
    display: inline-flex;
    align-items: center;
    font-size: 15px;
    justify-content: center;
    text-align: center;
    white-space: normal;
    line-height: 1.4em !important;
  }
  .ag-grid-table-header {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-weight: bold;
  }
  .ag-row .ag-cell{
    padding: 0 !important;
  }
  .ag-header-cell-label {
    justify-content: center;
  }
</style>
